import { render } from "./NotesReportCreation.vue?vue&type=template&id=033cfc1c&scoped=true"
import script from "./NotesReportCreation.vue?vue&type=script&lang=js"
export * from "./NotesReportCreation.vue?vue&type=script&lang=js"

import "./NotesReportCreation.vue?vue&type=style&index=0&id=033cfc1c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-033cfc1c"]])

export default __exports__